import styled from 'styled-components'

export default styled.div`
  position: absolute;
  top: 52px;
  display: ${props => !!props.alignCenter ? 'flex' : 'block'};
  align-items: ${props => !!props.alignCenter ? 'center' : ''};
  justify-content: ${props => !!props.alignCenter ? 'center' : ''};
  flex-wrap: ${props => !!props.alignCenter ? 'wrap' : ''};
  width: 100vw;
  height: ${document.body.clientHeight - 52}px;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;

  &.modal-open {
    overflow: hidden;
  }
`



// WEBPACK FOOTER //
// ./src/styles/PageContainer.js